module.exports = __webpack_public_path__ + "media/icons/menu/user-63ba9a478e7987f67de3f0ad64f9a7eb.svg";